export const en = {
  'already_logout': 'logout, please re-login',
  'logout': 'Log out',
  'user_login': 'User log in',
  'username': 'Username',
  'password': 'Password',
  'login': 'Log in',
  'hide_video': 'Hide video',
  'view_video': 'View video',
  'slow_audio_playback': 'Slow audio playback',
  'video_transcript': 'Video transcript',
  'wordbank': 'Word bank',
  'highlights': 'Highlights',
  'slow_playback': 'Slow playback',
  'view_translation': 'View translation',
  'dictionary': 'Dictionary',
  'fill_in_the_blanks': 'Fill in the blanks',
  'multiple_choice': 'Multiple choice',
  'complete_the_sentence': 'Complete the sentence',
  'unscramble_the_sentences': 'Unscramble the sentences',
  'the_assessment_begin_description': 'The assessment is about to begin. There are 4 parts in this test: listening, vocabulary, grammar, and reading. Each part contains 12-16 questions. Level of questions will be adjusted according to accuracy of answer.',
  'start_test': 'Start',
  'next': 'Next',
  'assessment_completed_description': 'Assessment completed. Thank you for taking the test!',
  'recommendation_according_assessment_result': 'Several courses are recommended to you based on your assessment result. You can view test result or the recommendation.',
  'view_result': 'View result',
  'my_recommendation': 'My recommendation',
  'view_assessment_history': 'View Assessment history',
  'assessment': 'Assessment',
  'view_recommendation': 'View recommendation',
  'assessment_history': 'Assessment history',
  'view_list': 'Back',
  'detail': 'Detail',
  'assessment_test': 'Assessment test',
  'listening_skill': 'Listening skill',
  'reading_skill': 'Reading skill',
  'vocabulary_skill': 'Vocabulary skill',
  'grammar_skill': 'Grammar skill',
  'test_date': 'Test date',
  'period': 'Period',
  'title': 'Title',
  'assigned_by': 'Assigned by',
  'listening': 'Listening',
  'reading': 'Reading',
  'total': 'Total',
  'pass': 'Status',
  'no_pass': 'not pass',
  'take_test': 'Take test',
  'n_a': 'N/A',
  'not_released': 'Not released',
  'test_is_over': 'Test is over',
  'go_test': 'Start Test',
  'completed': 'Completed',
  'no_test_found': 'No test found',
  'my_test': 'My test',
  'new_test': 'New test',
  'added_on': 'Added on',
  'assisgnment_history': 'Assisgnment history',
  'assign': 'Assign',
  'edit': 'Edit',
  'view_score': 'View score',
  'delete': 'Delete ',
  '_download': 'Download',
  'assignment_deleting_notice': 'By deleting the assignment, you will also delete the test record.',
  'deleting_confirm': 'Are you sure you want to delete?',
  'yes': 'OK',
  'cancel': 'Cancel',
  'has_been_assigned_to': 'has been assigned to',
  'no_assignment_has_been_made': 'No assignment has been made',
  'deleting_assignment_confirm': 'Are you sure you want to delete assignment?',
  'assign_to': 'Assign [{msg}] to',
  'no_class_is_assigned': 'No class is assigned',
  'submit_assign': 'Submit',
  'set_duration_of': 'Set duration of [{msg}]',
  'class': 'Class',
  'from': 'From',
  'to': 'To',
  'test_result_of': 'Test result of [{msg}]',
  'more': 'More',
  'please_check_time_format': 'Please check time format',
  'please_enter_valid_datetime': 'Please enter valid date and time',
  'replace': 'Replace',
  'add_test': 'Add test',
  'select': 'Select',
  'test': 'Test',
  'level': 'Level',
  'time_used': 'Time(s) used',
  'preview': 'Preview',
  'download': 'Download',
  'please_name_this_test': 'Please name this test',
  'please_choose_a_test': 'Please choose a test',
  'finish': 'Finish',
  'test_completed': 'Test completed',
  'class_name': 'Class name',
  'teacher': 'Teacher',
  'list_of_students': 'List of students',
  'edit_list': 'Edit',
  'edit_class': 'Edit class',
  'add_class': 'Add class',
  'import_class_information': 'Import class information',
  'export_all_classes': 'Export all classes',
  'download_list_of_class': 'Download list of class',
  'no_class_found': 'No class found',
  'file': 'File',
  'download_template': 'Download template',
  'class_management': 'Class',
  'class_information': 'Class information',
  'import_list_of_students': 'Import list of students',
  'add_current_student': 'Add current student(s)',
  'add_new': 'Add new',
  'remove': 'Remove',
  'add': 'Add',
  'at_least_4_characters': 'at least 4 characters',
  'name': 'Name',
  'student_id': 'Student ID',
  'no_assignment_found': 'No assignment found',
  'please_enter_course_name': 'Please enter course name',
  'update': 'Update',
  'add_course': 'Add course',
  'course_category': 'Course category',
  'daily_english': 'Daily English',
  'travel_shopping_english': 'Travel & Shopping English',
  'course_level': 'Course level',
  'show_selected': 'Show selected',
  'show_unselected': 'Show unselected',
  'course_has_not_been_saved_notice': 'Course has not been saved. Do you want to leave before saving?',
  'please_name_this_course': 'Please name this course',
  'please_choose_course': 'Please choose course(s)',
  'no_course_found': 'No course found',
  'my_favorites': 'My favorites',
  'all_courses': 'All courses',
  'selected_courses': 'Selected courses',
  'new_course': 'New course',
  'course_assignment_deleting_confirm': 'By deleting the assignment, you will also delete the course record.',
  'add_recourse': 'Add recourse',
  'keyword': 'Keyword',
  'search': 'Search',
  'show_my_uploads_only': 'Show my upload(s) only',
  'view': 'View',
  'upload_files': 'Upload files',
  'file_formats': 'File formats',
  'picture_format_required': 'Picture: jpg, png (not more than 2M)',
  'video_format_required': 'Video: mp4 (not more than 25M)',
  'audio_format_required': 'Audio: mp3 (not more than 25M)',
  'online_resources_management': 'Online resources',
  'please_choose_a_file': 'Please choose a file',
  'by_course': 'By course',
  'by_assignment': 'By assignment',
  'by_test': 'By test',
  'no_result_found': 'No result found',
  'score': 'Score',
  'class_performance': 'Class performance ',
  'view_individual': 'View individual',
  'individual_student': 'Individual student',
  'statistics': 'Statistics',
  'assignment': 'Assignment',
  'test_history': 'Test history',
  'not_taken': 'Not taken',
  'view_details': 'View details',
  'test_assigned': 'Test assigned',
  'score_management': 'Score',
  'video': 'Video',
  'transcript': 'Transcript',
  'follow': 'Follow up',
  'quiz': 'Quiz',
  'all': 'All',
  'single': 'Single',
  'times': 'Time(s)',
  'cosplay': 'Cosplay',
  'interactive': 'Interactive',
  'type': 'Type',
  'percentage': '%',
  'category': 'Category',
  'top_courses': 'Top courses',
  'course_reports': 'Course reports',
  'no_report_found': 'No report found',
  'learning_record': 'Learning record',
  'email': 'Email',
  'add_student': 'Add student',
  'import': 'Import',
  'export': 'Export',
  'no_student_found': 'No student found',
  'student_management': 'Student',
  'complete_list_of_students': 'Complete list of students',
  'add_teacher': 'Add teacher',
  'no_teacher_found': 'No teacher found',
  'teacher_management': 'Teacher',
  'complete_list_of_teachers': 'Complete list of teachers',
  'online_resources': 'Online resources',
  'message': 'Message',
  'history': 'History',
  'learning_record_mgr': 'Learning record',
  'customer_service': 'Customer Service',
  'lesson_language': 'Lesson Language',
  'lesson_category': 'Lesson Category',
  'lesson_level': 'Lesson Level',
  'add_or_select_list': 'Add or select list',
  'select_class': 'Select_class',
  '_finish': 'Finish',
  'input_name': 'Input name',
  'select_course': 'Select a course',
  'select_exam': 'Select a exam',
  'select_student': 'Select a student',
  'input_data': 'Input data',
  'generated_time': 'Generated time',
  'course': '{count} Course',
  'upload': 'Upload',
  'click_coursework_list': 'Click start creating coursework list',
  'without_coursework_list': 'without coursework list',
  'without_class_list': 'Without class list',
  'noData': 'No data yet',
  'without_list_of_established_classes': 'There are currently no established classes.',
  'without_list_of_established information': 'There is currently no established information.',
  'without_list_of_assigned_coursework': 'There is currently no created list of assigned coursework',
  'coursework_list_name': 'Coursework List Name',
  'please_enter_name': ' Please enter name... (limit 10 characters)',
  '_language': 'language',
  '_category': 'category',
  '_level': 'level',
  'attachment_list': 'Attachment list',
  'upload_tips': 'Click to select the attachment to be uploaded (please select the file to be uploaded from your computer)',
  'upload_rules': 'File size format is not limited, only one file can be uploaded at a time',
  'class_list': 'Class List',
  'selected_class': 'Selected Class',
  'student_list': 'Student List',
  'selected_student': 'Selected Student',
  'student': '0 Student | 1 Student | {count} Students',
  'Please_enter_username': 'Please enter username... (limit 10 characters)',
  'Please_enter_password': 'Please enter password... (limit 10 characters)',
  'Please_enter_user_name': 'Please enter name... (limit 10 characters)',
  'Please_enter_student_id': 'Please enter Id... (limit 10 characters)',
  'create_class': 'Click to start creating a class',
  'upload_excel': 'Upload Excel File',
  'download_excel': 'Download Excel File',
  'download_demo': 'Download Demo File',
  'assignment_score': 'Assignment Score',
  'assignment_list': 'Assignment Score List',
  'frequency_of_study': 'Frequency Of Study',
  'study_time': 'Study Time',
  'will_assign': 'You will assign',
  'list_of_coursework_for': 'List of coursework for',
  'you_have_assigned': 'You have assigned',
  'add_single_student': 'Add single student',
  'import_students': 'Import students',
  'note': 'Note! This action cannot be answered.',
  'want_delete': 'Yes I want to delete.',
  'successfully_deleted': 'Successfully deleted ',
  'coursework_deleted_successfully.': 'The coursework has been deleted successfully.',
  'Unassigned': 'Unassigned',
  'class_deleted_successfully': 'The class has been deleted successfully',
  'next_step': 'next',
  'upload_progress': 'Upload progress',
  'contains_course_attachments': 'Contains {count} course attachments',
  'select_question': 'Multiple choice',
  'examination_content': 'Examination Content',
  'assign_class': 'Assign a class',
  'number_of_courses': 'Number of course',
  'assigned_time': 'Assigned time',
  'course_content': 'Course content',
  'no_coursework_assigned': 'No coursework assigned',
  'no_assigned_courses': 'There is currently no teacher assigned any courses to you',
  'course_list': 'Course list',
  'attachment_file': 'Attachment',
  'start_the_course': 'Start the course',
  'browsing_history': 'Browsing history',
  'watch_time': 'Watch time',
  'after-class_test': 'After-Class Test',
  'watch_date': 'Watch date',
  'explain': 'explain',
  'explain_video': 'explain video',
  'lesson': 'lesson',
  'graphical_words': 'graphical words',
  'no_courses_found': 'No courses found',
  'no_courses_in_category': 'There are no courses in this category',
  'add_students_in_batches': 'Add students in batches',
  'results_of_after_school_test': 'The results of your after-school test are',
  'correct': 'Correct answer',
  'wrong': 'Wrong answer',
  'answer_rate': 'Answer rate',
  'restart': 'Restart',
  'submit': 'Submit',
  'go_to_writing_course': 'Go to writing course',
  'content': 'content',
  'play': 'play',
  'text': 'text',
  'fill_in_the_blank': 'fill in the blank',
  'understanding': 'understanding',
  'sentence': 'sentence',
  'reorganization': 'reorganization',
  'cumulative_number_of_views': 'Cumulative number of views in this lesson',
  'cumulative_times': 'Cumulative times',
  'last_update': 'Last update time',
  'cumulative_hours_of_views': 'Cumulative hours of viewing this lesson',
  'accumulated_hours': 'Accumulated hours',
  'select_a_sentence': 'Please select a sentence',
  'recording_start': 'Recording start',
  'recording_end': 'Recording end',
  'voice_recognition': 'Voice recognition...',
  'listen_sentence': 'Please listen to the sentence',
  'countdown': 'Countdown {count} seconds later',
  'change_password': 'Change password',
  'confirm': 'Confirm',
  'enter_old_password': 'Enter the old password...',
  'enter_new_password': 'Enter a new password...',
  'enter_new_password_again': 'Enter the new password again...'
}



// WEBPACK FOOTER //
// ./src/locales/us_en.js